import React, { useEffect, useState } from 'react';
import { X, Search, ChevronLeft, ChevronRight, ScrollText } from 'lucide-react';
import api from '../utils/api';

export default function LogsModal({ onClose }) {
  const [logs, setLogs] = useState([]);
  const [page, setPage] = useState(1);
  const [pagination, setPagination] = useState({ page: 1, total_pages: 1, total: 0, limit: 30 });
  const [query, setQuery] = useState('');
  const [inputValue, setInputValue] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const fetchLogs = async (nextPage = page, nextQuery = query) => {
    setLoading(true);
    setError('');
    try {
      const data = await api.getLogs({ page: nextPage, limit: 30, query: nextQuery });
      setLogs(data.logs || []);
      setPagination(data.pagination || { page: 1, total_pages: 1, total: 0, limit: 30 });
      setPage(nextPage);
      setQuery(nextQuery);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchLogs(1, '');
  }, []);

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal modal-xl" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <div className="modal-title">Logs hệ thống</div>
          <button className="btn-icon" onClick={onClose} type="button"><X size={18} /></button>
        </div>

        <div className="modal-body logs-modal-body">
          <div className="logs-toolbar">
            <div className="input-icon-wrap search-wrap">
              <Search size={16} />
              <input className="form-input with-icon" value={inputValue} onChange={(e) => setInputValue(e.target.value)} placeholder="Tìm theo người thao tác, action, summary, endpoint..." />
            </div>
            <button className="btn btn-ghost" type="button" onClick={() => fetchLogs(1, inputValue)}>
              <Search size={14} /> Tìm
            </button>
          </div>

          <div className="logs-summary-bar">
            <span><ScrollText size={14} /> Tổng logs: {pagination.total || 0}</span>
            <span>Trang {pagination.page || 1}/{pagination.total_pages || 1}</span>
          </div>

          {error && <div className="alert alert-error">{error}</div>}
          {loading ? (
            <div className="spinner-wrap"><div className="spinner" /></div>
          ) : logs.length === 0 ? (
            <div className="empty-state">Chưa có log nào</div>
          ) : (
            <div className="log-list">
              {logs.map((log) => (
                <div className="log-card" key={log.id}>
                  <div className="log-card-head">
                    <div>
                      <div className="log-summary">{log.summary}</div>
                      <div className="log-meta-line">
                        {log.actor_name || 'Guest'} · {log.actor_role || 'guest'} · {log.method} · {log.endpoint}
                      </div>
                    </div>
                    <div className="log-action-chip">{log.action}</div>
                  </div>
                  <div className="log-details-grid">
                    <div><strong>Thời gian:</strong> {log.created_at ? new Date(log.created_at).toLocaleString('vi-VN', { timeZone: 'Asia/Ho_Chi_Minh' }) : '—'}</div>
                    <div><strong>Entity:</strong> {log.entity_type || '—'} {log.entity_id ? `#${log.entity_id}` : ''}</div>
                    <div><strong>IP:</strong> {log.ip_address || '—'}</div>
                  </div>
                  {log.details && (
                    <pre className="log-details-pre">{JSON.stringify(log.details, null, 2)}</pre>
                  )}
                </div>
              ))}
            </div>
          )}
        </div>

        <div className="modal-footer">
          <div className="pagination compact-pagination">
            <button className="pagination-btn" type="button" disabled={(pagination.page || 1) <= 1} onClick={() => fetchLogs((pagination.page || 1) - 1, query)}>
              <ChevronLeft size={14} />
            </button>
            <span className="column-page-indicator">{pagination.page || 1}/{pagination.total_pages || 1}</span>
            <button className="pagination-btn" type="button" disabled={(pagination.page || 1) >= (pagination.total_pages || 1)} onClick={() => fetchLogs((pagination.page || 1) + 1, query)}>
              <ChevronRight size={14} />
            </button>
          </div>
          <button className="btn btn-ghost" type="button" onClick={onClose}>Đóng</button>
        </div>
      </div>
    </div>
  );
}
